import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"120px"} }, "작성일자", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", { class: "wage-transaction-label" }, "급여 서비스연월", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", { class: "wage-transaction-label" }, "급여 수량", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", { class: "wage-transaction-label" }, "급여 단가", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", { class: "wage-transaction-label" }, "급여 총액", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", { class: "wage-transaction-label" }, "급여 비고", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { class: "wage-transaction-label" }, "재무 서비스연월", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", { class: "wage-transaction-label" }, "재무 수량", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "wage-transaction-label" }, "재무 단가", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { class: "wage-transaction-label" }, "재무 총액", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "wage-transaction-label" }, "재무 비고", -1)
const _hoisted_13 = {
  key: 0,
  class: "pdf-preview"
}
const _hoisted_14 = ["src"]

import axios from 'axios';
import { ref, reactive, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';

// Props 정의
interface Props {
  hasData?: boolean;
  dataCount?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WageTransaction',
  props: {
    hasData: { type: Boolean, default: false },
    dataCount: { default: 0 }
  },
  setup(__props: any) {

const props = __props;

const store = useStore();

const inputWriteDate = ref(new Date().toISOString().split('T')[0]);

const form = reactive({
  whoUse: '공급받는자용',
  writeDate: '',
  supNum: '185-81-02287',
  supName: '㈜함우리',
  supBoss: '김승식',
  supAddr: '전주시 덕진구 기지로 77, 202-2803',
  supbizType: '구내식당업',
  supbizEvent: '집단급식위탁',
  supTell: '1833-7489',
  sisulName: store.state.AdminSisulName || '',
  wageCount: props.dataCount.toString(),
  wageUnitPrice: '17000',
  wageTotalPrice: '',
  wageBigo: '',
  wageSupplyDate: store.state.AdminYYMM || '',
  fnaCount: '',
  fnaUnitPrice: '',
  fnaTotalPrice: '',
  fnaBigo: '부가세 할인',
  fnaSupplyDate: store.state.AdminYYMM || '',
  code : store.state.AdminSisulCode || '',
  date : store.state.AdminYYMM || '',
  type : 'excel'
} as any)

const dialog = ref(false)
const pdfDialog = ref(false)
const loading = ref(false)
const pdfData = ref<string | null>(null)

const pdfSrc = computed(() => {
  if (pdfData.value) {
    return `data:application/pdf;base64,${pdfData.value}`
  }
  return ''
})

const openDialog = () => {
  dialog.value = true
}

const formatWriteDate = () => {
  const date = new Date(inputWriteDate.value);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const dayOfWeek = ['일', '월', '화', '수', '목', '금', '토'][date.getDay()];
  form.writeDate = `${year}년 ${month}월 ${day}일 ${dayOfWeek}요일`;
};

// 초기값 설정
onMounted(() => {
  formatWriteDate();
});

// dataCount가 변경될 때마다 wageCount 업데이트
watch(
  () => props.dataCount,
  (newValue) => {
    form.wageCount = newValue.toString();
    calculateWageTotal();
  }
);

const calculateWageTotal = () => {
  form.wageTotalPrice = form.wageCount * form.wageUnitPrice
}
const generatePdf = async () => {
  try {
    loading.value = true
    const response = await axios.post('/api/getWageTransaction', { form })
    
    if (response.data.pdf) {
      pdfData.value = response.data.pdf
      pdfDialog.value = true
      dialog.value = false
    }
  } catch (error) {
    console.error('PDF 생성 오류:', error)
    store.commit('showSnackbar', {
      text: "PDF 생성 중 오류가 발생했습니다.",
      color: "error"
    })
  } finally {
    loading.value = false
  }
}

const downloadPdf = () => {
  if (pdfData.value) {
    const link = document.createElement('a')
    link.href = `data:application/pdf;base64,${pdfData.value}`
    link.download = `거래명세서_${new Date().toISOString().split('T')[0]}.pdf`
    link.click()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.hasData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_btn, {
            variant: "outlined",
            color: "red",
            "prepend-icon": "mdi-mail",
            onClick: openDialog
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 거래명세서 생성 ")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dialog).value = $event)),
      width: "900"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "wage-transaction-title" }, {
              default: _withCtx(() => [
                _createTextVNode("거래명세서 생성 " + _toDisplayString(_unref(store).state.AdminYYMM), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_table, null, {
                              default: _withCtx(() => [
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", null, [
                                    _hoisted_2,
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: inputWriteDate.value,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputWriteDate).value = $event)),
                                        density: "compact",
                                        variant: "outlined",
                                        type: "date",
                                        onInput: formatWriteDate,
                                        "hide-details": ""
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_table, { class: "wage-transaction-table" }, {
                              default: _withCtx(() => [
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", null, [
                                    _hoisted_3,
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: form.wageSupplyDate,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.wageSupplyDate) = $event)),
                                        density: "compact",
                                        variant: "outlined",
                                        type: "month",
                                        "hide-details": ""
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_4,
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: form.wageCount,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.wageCount) = $event)),
                                        modelModifiers: { number: true },
                                        type: "number",
                                        density: "compact",
                                        variant: "outlined",
                                        onInput: calculateWageTotal,
                                        "hide-details": ""
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_5,
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: form.wageUnitPrice,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.wageUnitPrice) = $event)),
                                        modelModifiers: { number: true },
                                        type: "number",
                                        density: "compact",
                                        variant: "outlined",
                                        onInput: calculateWageTotal,
                                        "hide-details": ""
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_6,
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: form.wageTotalPrice,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.wageTotalPrice) = $event)),
                                        modelModifiers: { number: true },
                                        type: "number",
                                        density: "compact",
                                        variant: "outlined",
                                        readonly: "",
                                        "hide-details": ""
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_7,
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: form.wageBigo,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.wageBigo) = $event)),
                                        density: "compact",
                                        variant: "outlined",
                                        "hide-details": ""
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_table, { class: "wage-transaction-table" }, {
                              default: _withCtx(() => [
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", null, [
                                    _hoisted_8,
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: form.fnaSupplyDate,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.fnaSupplyDate) = $event)),
                                        density: "compact",
                                        variant: "outlined",
                                        type: "month",
                                        "hide-details": ""
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_9,
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: form.fnaCount,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.fnaCount) = $event)),
                                        modelModifiers: { number: true },
                                        type: "number",
                                        density: "compact",
                                        variant: "outlined",
                                        "hide-details": ""
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_10,
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: form.fnaUnitPrice,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.fnaUnitPrice) = $event)),
                                        modelModifiers: { number: true },
                                        type: "number",
                                        density: "compact",
                                        variant: "outlined",
                                        "hide-details": ""
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_11,
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: form.fnaTotalPrice,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.fnaTotalPrice) = $event)),
                                        modelModifiers: { number: true },
                                        type: "number",
                                        density: "compact",
                                        variant: "outlined",
                                        "hide-details": ""
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_12,
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: form.fnaBigo,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.fnaBigo) = $event)),
                                        density: "compact",
                                        variant: "outlined",
                                        "hide-details": ""
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "grey",
                  variant: "text",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (dialog.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 취소 ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "blue",
                  variant: "elevated",
                  onClick: generatePdf,
                  loading: loading.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" PDF 생성 ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: pdfDialog.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((pdfDialog).value = $event)),
      width: "1000"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "wage-transaction-title" }, {
              default: _withCtx(() => [
                _createTextVNode("거래명세서 미리보기")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (pdfData.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("iframe", {
                        src: pdfSrc.value,
                        width: "100%",
                        height: "600px",
                        frameborder: "0"
                      }, null, 8, _hoisted_14)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "grey",
                  variant: "text",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (pdfDialog.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 닫기 ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "green",
                  variant: "elevated",
                  onClick: downloadPdf
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 다운로드 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})